import { INextStepDef, IQualificationDef, NEXT_STEP_DEF_NAMES } from 'src/app/model/view/iqualification-def';
import { SyllabusService } from '../syllabus/syllabus.service';
import { BasisDefinitions } from './basis-definitions';

export class QualificationDefinitions {

    private static readonly TYPES = {
        VUXGRAN: 'VUXGRAN',
        COMPULSORY_SCHOOL: 'COMPULSORY_SCHOOL',
        GYAN: 'GYAN',
        GRAN: 'GRAN',
        UPPER_SECONDARY_EDUCATION: 'UPPER_SECONDARY_EDUCATION',
    };

    public static COMPULSORY_SCHOOL(service: SyllabusService): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: 9 },
                BasisDefinitions.MIN_YEARS_EXPERIENCE,
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
            ),
            code: QualificationDefinitions.TYPES.COMPULSORY_SCHOOL,
            name: 'Grundskolan',
            next: QualificationDefinitions.subjectStep(service),
        };
    }

    public static SAMI_SCHOOL(service: SyllabusService): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: 6 },
                BasisDefinitions.MIN_YEARS_EXPERIENCE,
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
            ),
            code: 'SAMI_SCHOOL',
            name: 'Sameskolan',
            next: QualificationDefinitions.subjectStep(service),
        };
    }

    public static UPPER_SECONDARY_EDUCATION(service: SyllabusService, vocational: boolean): IQualificationDef {
        const code = QualificationDefinitions.TYPES.UPPER_SECONDARY_EDUCATION;
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: null },
                BasisDefinitions.RELEVANT_COMPETENCE,
                BasisDefinitions.MIN_YEARS_EXPERIENCE,
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
                BasisDefinitions.VOCATIONAL_SKILLS_NOT_BY_TEACHING,
                BasisDefinitions.SUBJECT_IS_INCLUDED_IN_EXAMINA,
            ),
            code,
            name: 'Gymnasieskolan',
            next: vocational ? QualificationDefinitions.vocationalSubjectStep(service, code)
                : QualificationDefinitions.subjectStep(service),
        };
    }

    public static PRE_SCHOOL(service: SyllabusService): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: null },
                BasisDefinitions.MIN_YEARS_EXPERIENCE,
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
            ),
            code: 'PRE_SCHOOL',
            name: 'Förskolan',
            next: null,
        };
    }

    public static PRE_SCHOOL_CLASS(service: SyllabusService): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: null },
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
            ),
            code: 'PRE_SCHOOL_CLASS',
            name: 'Förskoleklass',
            next: null,
        };
    }

    public static LEISURE_TIME_CENTER(service: SyllabusService): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: null },
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
            ),
            code: 'LEISURE_TIME_CENTER',
            name: 'Fritidshem',
            next: null,
        };
    }

    public static SWEDISH_FOR_IMMIGRANTS(service: SyllabusService): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: null },
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
            ),
            code: 'SWEDISH_FOR_IMMIGRANTS',
            name: 'Kommunal vuxenutbildning i svenska för invandrare',
            next: null,
        };
    }

    public static GRINT(service: SyllabusService): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: null },
                BasisDefinitions.MIN_YEARS_EXPERIENCE,
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
            ),
            code: 'GRINT',
            name: 'Gymnasieskolans introduktionsprogram',
            next: QualificationDefinitions.subjectStep(service, QualificationDefinitions.TYPES.COMPULSORY_SCHOOL),
        };
    }

    public static BASIC_ADULT_EDUCATION(service: SyllabusService): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: null },
                BasisDefinitions.MIN_YEARS_EXPERIENCE,
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
            ),
            code: 'BASIC_ADULT_EDUCATION',
            name: 'Kommunal vuxenutbildning på grundläggande nivå',
            next: QualificationDefinitions.subjectStep(service),
        };
    }

    public static SPECIAL_SCHOOL_FOR_PUPILS_WITH_IMPAIRED_HEARING(service: SyllabusService): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date, orientation: string) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: 10, orientation },
                BasisDefinitions.MIN_YEARS_EXPERIENCE,
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
            ),
            code: 'SPECIAL_SCHOOL_FOR_PUPILS_WITH_IMPAIRED_HEARING',
            name: 'Specialskolan',
            next: QualificationDefinitions.specialSchoolSteps(service),
        };
    }

  public static TRGRAN(service: SyllabusService): IQualificationDef {
    return {
      availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
        { category, dateOfBirth, maxToYear: 9 },
        BasisDefinitions.MIN_YEARS_EXPERIENCE,
      ),
      code: 'TRGRAN',
      name: 'Ämnesområden inom anpassade grundskolan',
      next: QualificationDefinitions.subjectAreaStep(service,
        QualificationDefinitions.TYPES.GRAN),
    };
  }

  public static GRAN(service: SyllabusService): IQualificationDef {
    return {
      availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
        { category, dateOfBirth, maxToYear: 9 },
        BasisDefinitions.MIN_YEARS_EXPERIENCE,
      ),
      code: QualificationDefinitions.TYPES.GRAN,
      name: 'Anpassad grundskola',
      next: QualificationDefinitions.subjectStep(service),
    };
  }

  public static GYANIND(service: SyllabusService): IQualificationDef {
    return {
      availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
        { category, dateOfBirth, maxToYear: null },
        BasisDefinitions.MIN_YEARS_EXPERIENCE,
      ),
      code: 'GYANIND',
      name: 'Ämnesområden inom anpassade gymnasieskolans individuella program',
      next: QualificationDefinitions.subjectAreaStep(service,
        QualificationDefinitions.TYPES.GYAN),
    };
  }



  public static VUSGRAN(service: SyllabusService): IQualificationDef {
    return {
      availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
        { category, dateOfBirth, maxToYear: null },
        BasisDefinitions.MIN_YEARS_EXPERIENCE,
      ),
      code: 'VUSGRAN',
      name: 'Ämnesområden inom kommunal vuxenutbildning som anpassad utbildning på grundläggande nivå',
      next: QualificationDefinitions.subjectAreaStep(service,
        QualificationDefinitions.TYPES.VUXGRAN),
    };
  }

  public static VUXGRAN(service: SyllabusService): IQualificationDef {
    return {
      availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
        { category, dateOfBirth, maxToYear: null },
        BasisDefinitions.MIN_YEARS_EXPERIENCE,
      ),
      code: QualificationDefinitions.TYPES.VUXGRAN,
      name: 'Kommunal vuxenutbildning som anpassad utbildning på grundläggande nivå',
      next: QualificationDefinitions.subjectStep(service),
    };
  }

    public static ADULT_SECONDARY_EDUCATION(service: SyllabusService, vocational: boolean): IQualificationDef {
        return {
            availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
                { category, dateOfBirth, maxToYear: null },
                BasisDefinitions.COMPLETED_HIGHER_EDUCATION,
                BasisDefinitions.MIN_YEARS_EXPERIENCE,
                BasisDefinitions.VOCATIONAL_SKILLS_NOT_BY_TEACHING,
                BasisDefinitions.SUBJECT_IS_INCLUDED_IN_EXAMINA,
                BasisDefinitions.RELEVANT_COMPETENCE,
            ),
            code: 'ADULT_SECONDARY_EDUCATION',
            name: 'Kommunal vuxenutbildning på gymnasial nivå',
            next: vocational ?
                QualificationDefinitions.vocationalSubjectStep(service, QualificationDefinitions.TYPES.UPPER_SECONDARY_EDUCATION)
                : QualificationDefinitions.subjectStep(service),
        };
    }

  public static GYAN(service: SyllabusService, vocational: boolean): IQualificationDef {
    const code = QualificationDefinitions.TYPES.GYAN;
    return {
      availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
        { category, dateOfBirth, maxToYear: null },
        BasisDefinitions.RELEVANT_COMPETENCE,
        BasisDefinitions.MIN_YEARS_EXPERIENCE,
        BasisDefinitions.VOCATIONAL_SKILLS_NOT_BY_TEACHING,
        BasisDefinitions.SUBJECT_IS_INCLUDED_IN_EXAMINA,
      ),
      code,
      name: 'Anpassad gymnasieskola',
      next: vocational ? QualificationDefinitions.vocationalSubjectStep(service, code)
        : QualificationDefinitions.subjectStep(service),
    };
  }

  public static VUXGYAN(service: SyllabusService, vocational: boolean)
    : IQualificationDef {
    const code = 'VUXGYAN';
    return {
      availableBases: (category: string, dateOfBirth: Date) => BasisDefinitions.buildBases(
        { category, dateOfBirth, maxToYear: null },
        BasisDefinitions.RELEVANT_COMPETENCE,
        BasisDefinitions.MIN_YEARS_EXPERIENCE,
        BasisDefinitions.VOCATIONAL_SKILLS_NOT_BY_TEACHING,
        BasisDefinitions.SUBJECT_IS_INCLUDED_IN_EXAMINA,
      ),
      code,
      name: 'Kommunal vuxenutbildning som anpassad utbildning på gymnasial nivå',
      next: vocational ?
        QualificationDefinitions.vocationalSubjectStep(service,
          QualificationDefinitions.TYPES.GYAN)
        : QualificationDefinitions.subjectStep(service),
    };
  }

    private static subjectStep(service: SyllabusService, type?: string): INextStepDef {
        return {
            data: (code: string) => service.getNonVocationalSubjects(type ? type : code),
            label: 'Välj ämne',
            name: NEXT_STEP_DEF_NAMES.SUBJECT,
            next: null,
        };
    }

    private static vocationalSubjectStep(service: SyllabusService, type: string): INextStepDef {
        return {
            data: () => service.getVocationalSubjects(type),
            label: 'Välj ämne',
            name: NEXT_STEP_DEF_NAMES.SUBJECT,
            next: null,
        };
    }

    private static subjectAreaStep(service, type: string): INextStepDef {
    return {
      data: () => service.getSubjectAreaSubjects(type, type === this.TYPES.GRAN),
      label: 'Välj ämne',
      name: NEXT_STEP_DEF_NAMES.SUBJECT,
      next: null,
    };
  }

      private static specialSchoolSteps(service: SyllabusService): INextStepDef {
        const subject = QualificationDefinitions.subjectStep(service);
        subject.next = {
            data: () => service.getSpecialSchoolOrientations(),
            label: 'Välj inriktning',
            name: NEXT_STEP_DEF_NAMES.ORIENTATION,
            next: null,
        };
        return subject;
    }
}
